import { render, staticRenderFns } from "./accessRestricted.vue?vue&type=template&id=7bfe21b6&scoped=true&"
import script from "./accessRestricted.vue?vue&type=script&lang=js&"
export * from "./accessRestricted.vue?vue&type=script&lang=js&"
import style0 from "./accessRestricted.vue?vue&type=style&index=0&id=7bfe21b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfe21b6",
  null
  
)

export default component.exports